import { render, staticRenderFns } from "./BorrowMould.vue?vue&type=template&id=90da7f4a&scoped=true&"
import script from "./BorrowMould.vue?vue&type=script&lang=js&"
export * from "./BorrowMould.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90da7f4a",
  null
  
)

export default component.exports